import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = sessionStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
export const postFakeRegister = (data : any) => api.create(url.POST_FAKE_REGISTER, data);

// Login Method
export const postFakeLogin = (data : any) => api.create(url.POST_FAKE_LOGIN, data);

// postForgetPwd
export const postFakeForgetPwd = (data : any) => api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = (data : any) => api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data : any) => api.update(url.POST_EDIT_PROFILE + '/' + data.idx, data);

// Register Method
export const postJwtRegister = (url : string, data  :any) => {
  return api.create(url, data)
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
export const postJwtLogin = (data : any) => api.create(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
export const postJwtForgetPwd = (data : any) => api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = (data : any) => api.create(url.SOCIAL_LOGIN, data);

// Calendar
// get Events
export const getEvents = () => api.get(url.GET_EVENTS);

// get Events
export const getCategories = () => api.get(url.GET_CATEGORIES);

// get Upcomming Events
export const getUpCommingEvent = () => api.get(url.GET_UPCOMMINGEVENT);

// add Events
export const addNewEvent = (event : any) => api.create(url.ADD_NEW_EVENT, event);

// update Event
export const updateEvent = (event : any) => api.put(url.UPDATE_EVENT, event);

// delete Event
export const deleteEvent = (event : any) => api.delete(url.DELETE_EVENT, { headers: { event } });

// Chat
// get Contact
export const getDirectContact = () => api.get(url.GET_DIRECT_CONTACT);

// get Messages
export const getMessages = (roomId : any) => api.get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } });

// add Message
export const addMessage = (message : any) => api.create(url.ADD_MESSAGE, message);

// add Message
export const deleteMessage = (message : any) => api.delete(url.DELETE_MESSAGE, { headers: { message } });

// get Channels
export const getChannels = () => api.get(url.GET_CHANNELS);

// MailBox
//get Mail
export const getMailDetails = () => api.get(url.GET_MAIL_DETAILS);

// delete Mail
export const deleteMail = (forId: any) => api.delete(url.DELETE_MAIL, { headers: { forId } });

// unread Mail
export const unreadMail = (forId: any) => api.delete(url.UNREAD_MAIL, { headers: { forId } });

// star Mail
export const staredMail = (forId: any) => api.delete(url.STARED_MAIL, { headers: { forId } });

// label Mail
export const labelMail = (forId: any) => api.delete(url.LABEL_MAIL, { headers: { forId } });

// trash Mail
export const trashMail = (forId: any) => api.delete(url.TRASH_MAIL, { headers: { forId } });

// Ecommerce
// get Products
export const getProducts = () => api.get(url.GET_PRODUCTS);

// delete Product
export const deleteProducts = (product : any) => api.delete(url.DELETE_PRODUCT, { headers: { product } } );  

// add Products
export const addNewProduct = (product : any) => api.create(url.ADD_NEW_PRODUCT, product);
// update Products
export const updateProduct = (product : any) => api.update(url.UPDATE_PRODUCT, product ); 

// get Orders
export const getOrders = () => api.get(url.GET_ORDERS);

// add Order
export const addNewOrder = (order : any) => api.create(url.ADD_NEW_ORDER, order);

// update Order
export const updateOrder = (order : any) => api.update(url.UPDATE_ORDER, order);

// delete Order
export const deleteOrder = (order : any) => api.delete(url.DELETE_ORDER , { headers: { order } });

// get Customers
export const getCustomers = () => api.get(url.GET_CUSTOMERS);

// add Customers
export const addNewCustomer = (customer : any) => api.create(url.ADD_NEW_CUSTOMER, customer);

// update Customers
export const updateCustomer = (customer : any) => api.update(url.UPDATE_CUSTOMER, customer);

// delete Customers
export const deleteCustomer = (customer : any) => api.delete(url.DELETE_CUSTOMER, { headers: { customer } });

// get Sellers
export const getSellers = () => api.get(url.GET_SELLERS);

// Project
// get Project list 
export const getProjectList = () => api.get(url.GET_PROJECT_LIST);

// Tasks
// get Task
export const getTaskList = () => api.get(url.GET_TASK_LIST);

// add Task
export const addNewTask = (task : any) => api.create(url.ADD_NEW_TASK, task);

// update Task
export const updateTask = (task : any) => api.update(url.UPDATE_TASK, task);

// delete Task
export const deleteTask = (task : any) => api.delete(url.DELETE_TASK, { headers: { task }});

// Kanban Board
export const getTasks = () => api.get(url.GET_TASKS);
export const addNewTasks = (card: any) => api.create(url.ADD_TASKS, card)
export const updateTasks = (card: any) => api.put(url.UPDATE_TASKS, card)
export const deleteTasks = (card: any) => api.delete(url.DELETE_TASKS, { headers: {card} })

// CRM
// get Contacts
export const getContacts = () => api.get(url.GET_CONTACTS);

// add Contact
export const addNewContact = (contact : any) => api.create(url.ADD_NEW_CONTACT, contact);

// update Contact
export const updateContact = (contact : any) => api.update(url.UPDATE_CONTACT, contact);

// delete Contact
export const deleteContact = (contact : any) => api.delete(url.DELETE_CONTACT, { headers: { contact }});

// get Companies
export const getCompanies = () => api.get(url.GET_COMPANIES);

// add Companies
export const addNewCompanies = (company : any) => api.create(url.ADD_NEW_COMPANIES, company);

// update Companies
export const updateCompanies = (company : any) => api.update(url.UPDATE_COMPANIES, company);

// delete Companies
export const deleteCompanies = (company : any) => api.delete(url.DELETE_COMPANIES, { headers: {company}});

// get Deals
export const getDeals = () => api.get(url.GET_DEALS);

// get Leads
export const getLeads = () => api.get(url.GET_LEADS);

// add Lead
export const addNewLead = (lead : any) => api.create(url.ADD_NEW_LEAD, lead);

// update Lead
export const updateLead = (lead : any) => api.update(url.UPDATE_LEAD, lead);

// delete Lead
export const deleteLead = (lead : any) => api.delete(url.DELETE_LEAD, { headers: {lead}});

// Crypto
// Transation
export const getTransationList = () => api.get(url.GET_TRANSACTION_LIST);

// Order List
export const getOrderList = () => api.get(url.GET_ORDRER_LIST);

// Invoice
//get Invoice
export const getInvoices = () => api.get(url.GET_INVOICES);

// add Invoice
export const addNewInvoice = (invoice : any) => api.create(url.ADD_NEW_INVOICE, invoice);

// update Invoice
export const updateInvoice = (invoice : any) => api.update(url.UPDATE_INVOICE + '/' + invoice._id, invoice);

// delete Invoice
export const deleteInvoice = (invoice : any) => api.delete(url.DELETE_INVOICE + '/' + invoice);

// Support Tickets 
// Tickets
export const getTicketsList = () => api.get(url.GET_TICKETS_LIST);

// add Tickets 
export const addNewTicket = (ticket : any) => api.create(url.ADD_NEW_TICKET, ticket);

// update Tickets 
export const updateTicket = (ticket : any) => api.update(url.UPDATE_TICKET, ticket);

// delete Tickets 
export const deleteTicket = (ticket : any) => api.delete(url.DELETE_TICKET, { headers: {ticket}});

// Dashboard Analytics

// Sessions by Countries
export const getAllData = () => api.get(url.GET_ALL_DATA);
export const getHalfYearlyData = () => api.get(url.GET_HALFYEARLY_DATA);
export const getMonthlyData = () => api.get(url.GET_MONTHLY_DATA);

// Audiences Metrics
export const getAllAudiencesMetricsData = () => api.get(url.GET_ALLAUDIENCESMETRICS_DATA);
export const getMonthlyAudiencesMetricsData = () => api.get(url.GET_MONTHLYAUDIENCESMETRICS_DATA);
export const getHalfYearlyAudiencesMetricsData = () => api.get(url.GET_HALFYEARLYAUDIENCESMETRICS_DATA);
export const getYearlyAudiencesMetricsData = () => api.get(url.GET_YEARLYAUDIENCESMETRICS_DATA);

// Users by Device
export const getTodayDeviceData = () => api.get(url.GET_TODAYDEVICE_DATA);
export const getLastWeekDeviceData = () => api.get(url.GET_LASTWEEKDEVICE_DATA);
export const getLastMonthDeviceData = () => api.get(url.GET_LASTMONTHDEVICE_DATA);
export const getCurrentYearDeviceData = () => api.get(url.GET_CURRENTYEARDEVICE_DATA);

// Audiences Sessions by Country
export const getTodaySessionData = () => api.get(url.GET_TODAYSESSION_DATA);
export const getLastWeekSessionData = () => api.get(url.GET_LASTWEEKSESSION_DATA);
export const getLastMonthSessionData = () => api.get(url.GET_LASTMONTHSESSION_DATA);
export const getCurrentYearSessionData = () => api.get(url.GET_CURRENTYEARSESSION_DATA);

// Dashboard CRM

// Balance Overview
export const getTodayBalanceData = () => api.get(url.GET_TODAYBALANCE_DATA);
export const getLastWeekBalanceData = () => api.get(url.GET_LASTWEEKBALANCE_DATA);
export const getLastMonthBalanceData = () => api.get(url.GET_LASTMONTHBALANCE_DATA);
export const getCurrentYearBalanceData = () => api.get(url.GET_CURRENTYEARBALANCE_DATA);

// Dial Type
export const getTodayDealData = () => api.get(url.GET_TODAYDEAL_DATA);
export const getWeeklyDealData = () => api.get(url.GET_WEEKLYDEAL_DATA);
export const getMonthlyDealData = () => api.get(url.GET_MONTHLYDEAL_DATA);
export const getYearlyDealData = () => api.get(url.GET_YEARLYDEAL_DATA);

// Sales Forecast
export const getOctSalesData = () => api.get(url.GET_OCTSALES_DATA);
export const getNovSalesData = () => api.get(url.GET_NOVSALES_DATA);
export const getDecSalesData = () => api.get(url.GET_DECSALES_DATA);
export const getJanSalesData = () => api.get(url.GET_JANSALES_DATA);

// Dashboard Ecommerce
// Revenue
export const getAllRevenueData = () => api.get(url.GET_ALLREVENUE_DATA);
export const getMonthRevenueData = () => api.get(url.GET_MONTHREVENUE_DATA);
export const getHalfYearRevenueData = () => api.get(url.GET_HALFYEARREVENUE_DATA);
export const getYearRevenueData = () => api.get(url.GET_YEARREVENUE_DATA);


// Dashboard Crypto
// Portfolio
export const getBtcPortfolioData = () => api.get(url.GET_BTCPORTFOLIO_DATA);
export const getUsdPortfolioData = () => api.get(url.GET_USDPORTFOLIO_DATA);
export const getEuroPortfolioData = () => api.get(url.GET_EUROPORTFOLIO_DATA);

// Market Graph
export const getAllMarketData = () => api.get(url.GET_ALLMARKETDATA_DATA);
export const getYearMarketData = () => api.get(url.GET_YEARMARKET_DATA);
export const getMonthMarketData = () => api.get(url.GET_MONTHMARKET_DATA);
export const getWeekMarketData = () => api.get(url.GET_WEEKMARKET_DATA);
export const getHourMarketData = () => api.get(url.GET_HOURMARKET_DATA);

// Dashboard Project
// Project Overview
export const getAllProjectData = () => api.get(url.GET_ALLPROJECT_DATA);
export const getMonthProjectData = () => api.get(url.GET_MONTHPROJECT_DATA);
export const gethalfYearProjectData = () => api.get(url.GET_HALFYEARPROJECT_DATA);
export const getYearProjectData = () => api.get(url.GET_YEARPROJECT_DATA);

// Project Status
export const getAllProjectStatusData = () => api.get(url.GET_ALLPROJECTSTATUS_DATA);
export const getWeekProjectStatusData = () => api.get(url.GET_WEEKPROJECTSTATUS_DATA);
export const getMonthProjectStatusData = () => api.get(url.GET_MONTHPROJECTSTATUS_DATA);
export const getQuarterProjectStatusData = () => api.get(url.GET_QUARTERPROJECTSTATUS_DATA);

// dashboard job
export const getApplicationsStatistic = (roomId : any) => api.get(url.GET_JOBAPPLICATIONSTATISTIC, roomId);

// Dashboard NFT
// Marketplace
export const getAllMarketplaceData = () => api.get(url.GET_ALLMARKETPLACE_DATA);
export const getMonthMarketplaceData = () => api.get(url.GET_MONTHMARKETPLACE_DATA);
export const gethalfYearMarketplaceData = () => api.get(url.GET_HALFYEARMARKETPLACE_DATA);
export const getYearMarketplaceData = () => api.get(url.GET_YEARMARKETPLACE_DATA);

// Project
export const addProjectList = (project : any) => api.create(url.ADD_NEW_PROJECT, project);
export const updateProjectList = (project : any) => api.put(url.UPDATE_PROJECT, project);
export const deleteProjectList = (project : any) => api.delete(url.DELETE_PROJECT, { headers: { project } });

// Pages > Team
export const getTeamData = () => api.get(url.GET_TEAMDATA);
export const deleteTeamData = (team : any) => api.delete(url.DELETE_TEAMDATA, { headers: { team } });
export const addTeamData = (team : any) => api.create(url.ADD_NEW_TEAMDATA, team);
export const updateTeamData = (team : any) => api.put(url.UPDATE_TEAMDATA, team);

// File Manager

// Folder
export const getFolders = () => api.get(url.GET_FOLDERS);
export const deleteFolder = (folder : any) => api.delete(url.DELETE_FOLDER, { headers: { folder } });
export const addNewFolder = (folder : any) => api.create(url.ADD_NEW_FOLDER, folder);
export const updateFolder = (folder : any) => api.put(url.UPDATE_FOLDER, folder);

// File
export const getFiles = () => api.get(url.GET_FILES);
export const deleteFile = (file : any) => api.delete(url.DELETE_FILE, { headers: { file } });
export const addNewFile = (file : any) => api.create(url.ADD_NEW_FILE, file);
export const updateFile = (file : any) => api.put(url.UPDATE_FILE, file);

// To Do
export const getTodos = () => api.get(url.GET_TODOS);
export const deleteTodo = (todo : any) => api.delete(url.DELETE_TODO, { headers: { todo } });
export const addNewTodo = (todo : any) => api.create(url.ADD_NEW_TODO, todo);
export const updateTodo = (todo : any) => api.put(url.UPDATE_TODO, todo);

// To do Project
export const getProjects = () => api.get(url.GET_PROJECTS);
export const addNewProject = (project : any) => api.create(url.ADD_NEW_TODO_PROJECT, project);

//API Key
export const getAPIKey = () => api.get(url.GET_API_KEY);

//Job Application
export const getJobApplicationList = () => api.get(url.GET_APPLICATION_LIST);
export const addNewJobApplicationList = (job: any) => api.create(url.ADD_NEW_APPLICATION_LIST, job);
export const updateJobApplicationList = (job: any) => api.put(url.UPDATE_APPLICATION_LIST, job);
export const deleteJobApplicationList = (job: any) => api.delete(url.DELETE_APPLICATION_LIST, { headers: { job } });

// candidate list
export const getJobCandidateList = () => api.get(url.GET_CANDIDATE, '');
export const addJobCandidate = (candidate : any) => api.create(url.ADD_NEW_CANDIDATE, candidate);
export const updateJobCandidate = (candidate : any) => api.update(url.UPDATE_CANDIDATE, candidate);
export const deleteJobCandidate = (candidate : any) => api.delete(url.DELETE_CANDIDATE, { headers: {candidate} });

// category list
export const getcategoryList = () => api.get(url.GET_CATEGORY_LIST);
export const addcategoryList = (category : any) => api.create(url.ADD_CATEGORY_LIST, category);

// grid
export const getCandidateGrid = () => api.get(url.GET_CANDIDATE_GRID);
export const addCandidateGrid = (category : any) => api.create(url.ADD_CANDIDATE_GRID, category);

// Audit Logs - ADDED
// Get audit logs list with filters
export const getAuditLogs = (params?: any) => api.get(url.GET_AUDIT_LOGS, params);

// Get audit log by ID
export const getAuditLogById = (id: number) => api.get(`${url.GET_AUDIT_LOGS}/${id}`);

// Get audit logs statistics
export const getAuditLogStatistics = (params?: any) => api.get(url.GET_AUDIT_LOG_STATISTICS, params);

// Export audit logs (Excel or CSV)
export const exportAuditLogs = (params?: any) => api.get(url.EXPORT_AUDIT_LOGS, params);

// User Management - ADDED
// Get users list with filters
export const getUsers = (params?: any) => api.get(url.GET_USERS, params);

// Get user by ID
export const getUserById = (id: number) => api.get(`${url.GET_USER_BY_ID}/${id}`);

// Create user
export const createUser = (data: any) => api.create(url.CREATE_USER, data);

// Update user
export const updateUser = (id: number, data: any) => api.put(`${url.UPDATE_USER}`, data);

// Delete user
export const deleteUser = (id: number) => api.delete(`${url.DELETE_USER}/${id}`);

// Toggle user status (Lock/Unlock)
export const toggleUserStatus = (id: number, status: string) => api.update(`${url.TOGGLE_USER_STATUS}/${id}/status`, { status });

// Upload user avatar (same logic as uploadCurrentUserAvatar)
export const uploadUserAvatar = async (id: number, file: File) => {
  // Step 1: Upload to FileStorage
  const uploadResponse = await uploadFileToStorage('UserAvatars', file);
  const uploadData = uploadResponse.data || uploadResponse;
  const avatarUrl = uploadData.url;
  
  // Step 2: Update user's avatar URL in identity service
  // Try new API (JSON) first, fallback to old API (multipart) if 415 error
  try {
    const updateResponse = await api.create(`${url.UPLOAD_USER_AVATAR}/${id}/avatar`, {
      avatarUrl: avatarUrl
    });
    
    return {
      ...updateResponse,
      data: {
        objectKey: uploadData.objectKey,
        avatarUrl: avatarUrl,
      }
    };
  } catch (error: any) {
    // If backend returns 415 (Unsupported Media Type), try old API with file
    if (error?.response?.status === 415) {
      console.warn('Backend chưa hỗ trợ JSON upload, fallback sang multipart/form-data');
      const formData = new FormData();
      formData.append('avatar', file);
      await api.create(`${url.UPLOAD_USER_AVATAR}/${id}/avatar`, formData);
      
      // Return FileStorage URL anyway (ignore backend's placeholder URL)
      return {
        data: {
          objectKey: uploadData.objectKey,
          avatarUrl: avatarUrl,
        }
      };
    }
    throw error;
  }
};

// Update user permissions
export const updateUserPermissions = (id: number, data: any) => api.update(`${url.UPDATE_USER_PERMISSIONS}/${id}/permissions`, data);

// Get departments list
export const getDepartments = () => api.get(url.GET_DEPARTMENTS);

// Get roles list (for user management dropdown)
export const getRoles = (params?: any) => api.get(url.GET_ROLES, params);


// Role Management - ADDED

// Get role groups list
export const getRoleGroups = (params?: any) => api.get(url.GET_ROLE_GROUPS, params);

// Get role group by ID
export const getRoleGroupById = (id: number) => api.get(`${url.GET_ROLE_GROUP_BY_ID}/${id}`);

// Create role group
export const createRoleGroup = (data: any) => api.create(url.CREATE_ROLE_GROUP, data);

// Update role group
export const updateRoleGroup = (id: number, data: any) => api.put(url.UPDATE_ROLE_GROUP, data);

// Assign role permissions
export const assignRolePermissions = (id: number, data: any) => api.put(`${url.UPDATE_ROLE_GROUP}/${id}/permissions`, data);

// Delete role group
export const deleteRoleGroup = (id: number, forceDelete?: boolean) => {
  const config = forceDelete ? { params: { forceDelete: true } } : undefined;
  return api.delete(`${url.DELETE_ROLE_GROUP}/${id}`, config);
};

// Get modules
export const getModules = (isActive?: boolean) => api.get(url.GET_MODULES, isActive !== undefined ? { isActive } : undefined);

// Get dynamic sidebar menu tree (đã lọc theo quyền user hiện tại)
export const getUserMenu = () => api.get(url.GET_USER_MENU);

// Get permissions
export const getPermissions = (moduleId?: number, isActive?: boolean) => {
  const params: any = {};
  if (moduleId !== undefined) params.moduleId = moduleId;
  if (isActive !== undefined) params.isActive = isActive;
  return api.get(url.GET_PERMISSIONS, Object.keys(params).length > 0 ? params : undefined);
};

// Get permissions grouped by module
export const getPermissionsByModule = () => api.get(url.GET_PERMISSIONS_BY_MODULE);

// Module Management (quản lý module cha/con) - ADDED

// Get module detail by ID (dùng cho form edit)
export const getModuleById = (id: number) => api.get(`${url.GET_MODULE_BY_ID}/${id}`);

// Get permissions của một module
export const getModulePermissions = (id: number) => api.get(`${url.GET_MODULE_PERMISSIONS}/${id}/permissions`);

// Create module
export const createModule = (data: any) => api.create(url.CREATE_MODULE, data);

// Update module
export const updateModule = (id: number, data: any) => api.put(`${url.UPDATE_MODULE}/${id}`, data);

// Delete module (soft delete)
export const deleteModule = (id: number) => api.delete(`${url.DELETE_MODULE}/${id}`);

// Permission Management (tạo permission khi tạo module) - ADDED
export const createPermission = (data: any) => api.create(url.CREATE_PERMISSION, data);
export const deletePermission = (id: number) => api.delete(`${url.DELETE_PERMISSION}/${id}`);

// System Configuration - ADDED

// Get system configuration
export const getSystemConfig = () => api.get(url.GET_SYSTEM_CONFIG);

// Update region configuration — backend expose PUT, không phải PATCH nên phải dùng api.put
export const updateRegionConfig = (data: any) => api.put(url.UPDATE_REGION_CONFIG, data);

// Update lookup configuration — tương tự, backend expose PUT
export const updateLookupConfig = (data: any) => api.put(url.UPDATE_LOOKUP_CONFIG, data);

// Validate base URL
export const validateBaseUrl = (urlToValidate: string) => api.create(url.VALIDATE_URL, { url: urlToValidate });

// Xóa cache Redis "system-configuration" bên ticket-service ngay sau khi lưu cấu hình hệ thống
// thành công (xem slices/systemConfiguration/thunk.ts) - ADDED
export const invalidateTicketSystemConfigCache = () => api.create(url.INVALIDATE_TICKET_SYSTEM_CONFIG_CACHE, {});

// Branding Configuration - ADDED

// Get branding configuration
export const getBrandingConfig = () => api.get(url.GET_BRANDING_CONFIG);

// Update branding configuration
export const updateBrandingConfig = (data: any) => api.update(url.UPDATE_BRANDING_CONFIG, data);

// Upload logo
export const uploadLogo = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.create(url.UPLOAD_LOGO, formData);
};

// Delete logo
export const deleteLogo = () => api.delete(url.DELETE_LOGO);

// Upload favicon
export const uploadFavicon = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.create(url.UPLOAD_FAVICON, formData);
};

// Delete favicon
export const deleteFavicon = () => api.delete(url.DELETE_FAVICON);

// Get audit log for branding configuration
export const getBrandingAuditLog = (params?: any) => api.get(url.GET_AUDIT_LOG, params);
// Agent Management - ADDED

// Get agents list
export const getAgents = (params?: any) => api.get(url.GET_AGENTS, params);

// Create new agent
export const createNewAgent = (data: any) => api.create(url.CREATE_AGENT, data);

// Update existing agent
export const updateExistingAgent = (data: any) => api.put(url.UPDATE_AGENT, data);

// Check agent code availability
export const checkAgentCodeAvailability = (code: string) =>
  api.get(url.CHECK_AGENT_CODE, { params: { Code: code } });

// Change Password - ADDED
export const changeUserPassword = (userId: number, data: {confirmPassword: string; currentPassword: string; newPassword: string }) =>
  api.put(`${url.CHANGE_PASSWORD}${userId}/change-password`, data);



export const getUserProfile = (): Promise<any> => api.get(url.GET_USER_PROFILE);

export const updateUserProfile = (userId: number, data: any) => api.put(`${url.UPDATE_USER_PROFILE}/${userId}`, data);

// Upload file to FileStorage service
export const uploadFileToStorage = (screenName: string, file: File) => {
  const formData = new FormData();
  formData.append('screenName', screenName);
  formData.append('file', file);
  return api.create('/system-api/FileStorage', formData);
};

// Upload current user avatar (2-step: upload to FileStorage, then update user avatar in identity service)
export const uploadCurrentUserAvatar = async (userId: number, file: File) => {
  // Step 1: Upload to FileStorage
  const uploadResponse = await uploadFileToStorage('UserAvatars', file);
  const uploadData = uploadResponse.data || uploadResponse;
  const avatarUrl = uploadData.url;
  
  // Step 2: Update user's avatar URL in identity service
  // Try new API (JSON) first, fallback to old API (multipart) if 415 error
  try {
    const updateResponse = await api.create(`${url.UPLOAD_USER_AVATAR}/${userId}/avatar`, {
      avatarUrl: avatarUrl
    });
    
    return {
      ...updateResponse,
      data: {
        objectKey: uploadData.objectKey,
        avatarUrl: avatarUrl,
      }
    };
  } catch (error: any) {
    // If backend returns 415 (Unsupported Media Type), try old API with file
    if (error?.response?.status === 415) {
      console.warn('Backend chưa hỗ trợ JSON upload, fallback sang multipart/form-data');
      const formData = new FormData();
      formData.append('avatar', file);
      await api.create(`${url.UPLOAD_USER_AVATAR}/${userId}/avatar`, formData);
      
      // Return FileStorage URL anyway (ignore backend's placeholder URL)
      return {
        data: {
          objectKey: uploadData.objectKey,
          avatarUrl: avatarUrl,
        }
      };
    }
    throw error;
  }
};

// Tenant Management API helpers - ADD TO fakebackend_helper.ts

// Get tenants list
export const getTenants = (params?: any) => api.get(url.GET_TENANTS, params);

// Get tenant by ID
export const getTenantById = (id: number) => api.get(`${url.GET_TENANT_BY_ID}/${id}`);

// Create tenant
export const createTenant = (data: any) => api.create(url.CREATE_TENANT, data);

// Update tenant
export const updateTenant = (id: number, data: any) => api.put(`${url.UPDATE_TENANT}`, data);

// Delete tenant
export const deleteTenant = (id: number) => api.delete(`${url.DELETE_TENANT}/${id}`);

// Check tenant code availability
export const checkTenantCode = (code: string, excludeId?: number) => {
  const params = excludeId ? { Code: code, ExcludeId: excludeId } : { Code: code };
  return api.get(url.CHECK_TENANT_CODE, params);
};

// Get tenant managers list
export const getTenantManagers = () => api.get(url.GET_TENANT_MANAGERS);

// Ticket Lookup (tra cứu kết quả vé số qua QR — public, không cần đăng nhập)
// Token la chuoi base64url do ticket-service ma hoa (AES-256-GCM), tu chua ky quay/so ve/ky hieu
// nen chi can truyen nguyen token, khong con periodId/ticketNumber/symbol/sig rieng le - ADDED
export const lookupTicket = (token: string) =>
  api.get(`${url.LOOKUP_TICKET}/${encodeURIComponent(token)}`);

// Sinh chữ ký cho 1 vé cụ thể (Cổng tra cứu kết quả) — cần đăng nhập, dùng để lấy URL tra cứu
// map vào khối "Quét mã QR để tra cứu nhanh" thay vì phải quét QR in sẵn trên vé - ADDED
export const getTicketSignature = (periodId: number | string, ticketNumber: string, symbol: string) =>
  api.get(`${url.GET_TICKET_SIGNATURE}/${periodId}/${encodeURIComponent(ticketNumber)}/${encodeURIComponent(symbol)}`);

// Giải mã ngược 1 token đã sinh (kỳ/số vé/ký hiệu) — dùng để Cổng tra cứu kết quả tự điền lại form
// khi mở từ 1 vé cụ thể (VD: click vào thẻ vé trong màn "Tra cứu vé số vừa tạo") - ADDED
export const decodeTicketToken = (token: string) =>
  api.get(`${url.DECODE_TICKET_TOKEN}/${encodeURIComponent(token)}`);

// Ticket Design Template Management - ADDED

// Lấy danh sách templates với filters
export const getTicketDesignTemplates = (params?: any) => api.get(url.GET_TICKET_DESIGN_TEMPLATES, params);

// Lấy chi tiết template theo ID
export const getTicketDesignTemplateById = (id: number) => api.get(`${url.GET_TICKET_DESIGN_TEMPLATE_BY_ID}/${id}`);

// Lấy Signed URL để preview file
export const getTicketDesignTemplateFileUrl = (id: number) => api.get(`${url.GET_TICKET_DESIGN_TEMPLATE_FILE_URL}/${id}/file-url`);

// Tạo mới template
export const createTicketDesignTemplate = (data: any) => api.create(url.CREATE_TICKET_DESIGN_TEMPLATE, data);

// Cập nhật template
export const updateTicketDesignTemplate = (id: number, data: any) => api.put(`${url.UPDATE_TICKET_DESIGN_TEMPLATE}/${id}`, data);

export const updateTicketDesignTemplateFile = (id: number, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.put(`${url.UPDATE_TICKET_DESIGN_TEMPLATE}/${id}/file`, formData);
};

export const deleteTicketDesignTemplateFile = (id: number) => api.delete(`${url.UPDATE_TICKET_DESIGN_TEMPLATE}/${id}/file`);

// Lưu vị trí/kích thước các phần tử overlay (mã vé, số vé, QR, ngày mở thưởng...) trên ảnh mẫu vé
export const updateTicketDesignTemplateLayout = (id: number, layoutJson: string | null) =>
  api.put(`${url.UPDATE_TICKET_DESIGN_TEMPLATE}/${id}/layout`, { layoutJson });

// Xóa template
export const deleteTicketDesignTemplate = (id: number) => api.delete(`${url.DELETE_TICKET_DESIGN_TEMPLATE}/${id}`);

// Phê duyệt template
export const approveTicketDesignTemplate = (id: number) => api.create(`${url.APPROVE_TICKET_DESIGN_TEMPLATE}/${id}/approve`, {});

export const unlockTicketDesignTemplate = (id: number) => api.create(`${url.UNLOCK_TICKET_DESIGN_TEMPLATE}/${id}/unlock`, {});

// Issuance Plan Management - ADDED
export const getIssuancePlans = (params?: any) => api.get(url.GET_ISSUANCE_PLANS, params);
export const getIssuancePlanById = (id: number) => api.get(`${url.GET_ISSUANCE_PLAN_BY_ID}/${id}`);
export const createIssuancePlan = (data: any) => api.create(url.CREATE_ISSUANCE_PLAN, data);
export const getIssuancePlanStatuses = () => api.get(url.GET_ISSUANCE_PLAN_STATUSES);
export const approveIssuancePlan = (id: number) => api.create(`${url.APPROVE_ISSUANCE_PLAN}/${id}/approve`, {});
export const rejectIssuancePlan = (id: number, reason: string) => api.create(`${url.REJECT_ISSUANCE_PLAN}/${id}/reject`, { reason });
export const cancelIssuancePlan = (id: number, reason: string) => api.create(`${url.REJECT_ISSUANCE_PLAN}/${id}/cancel`, { reason });
export const sendToPrintIssuancePlan = (id: number) => api.create(`${url.SEND_TO_PRINT_ISSUANCE_PLAN}/${id}/send-to-print`, {});
export const downloadPrintPackageIssuancePlan = (id: number) => api.download(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/${id}/print-package`);
export const createPrintPackageExportJob = (id: number) => api.create(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/${id}/print-package/jobs`, {});
export const getPrintPackageExportJob = (jobId: string) =>
  api.get(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/print-package/jobs/${jobId}/progress`);
// Backend tra ve { url, fileName } — URL cong khai tren MinIO, KHONG proxy byte (goi in co the toi
// ~400MB) qua ticket-service. Goi triggerBrowserDownload(url) de tai truc tiep tu MinIO.
export const downloadPrintPackageExportJob = (jobId: string) =>
  api.get(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/print-package/jobs/${jobId}/download`);
export const receiveWarehouseIssuancePlan = (id: number, actualReceivedQuantity: number) =>
  api.create(`${url.RECEIVE_WAREHOUSE_ISSUANCE_PLAN}/${id}/receive-warehouse`, { actualReceivedQuantity });

// Lịch sử lỗi job export gói in (bao gồm cả lỗi do StalledJobWatchdogService phát hiện)
export const getPrintPackageJobErrorLogsApi = (issuancePlanId: number) =>
  api.get(`${url.GET_PRINT_PACKAGE_JOB_ERROR_LOGS}/${issuancePlanId}/print-package/error-logs`);

// Xuất file ảnh QR (.png, gom theo thư mục Symbol, nén 1 file .zip) — luồng song song, độc lập với
// Gửi in/print-package ở trên. Cùng dùng thunk pattern.
export const createQrImageExportJob = (id: number) => api.create(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/${id}/qr-image/jobs`, {});
export const getQrImageExportJob = (jobId: string) =>
  api.get(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/qr-image/jobs/${jobId}/progress`);
// Backend trả về { url, fileName } — URL công khai trên MinIO, không proxy byte qua ticket-service.
export const downloadQrImageExportJob = (jobId: string) =>
  api.get(`${url.PRINT_PACKAGE_ISSUANCE_PLAN}/qr-image/jobs/${jobId}/download`);
export const getQrImageJobErrorLogsApi = (issuancePlanId: number) =>
  api.get(`${url.GET_PRINT_PACKAGE_JOB_ERROR_LOGS}/${issuancePlanId}/qr-image/error-logs`);

// Ticket Type Management - ADDED
export const getTicketTypes = (params?: any) => api.get(url.GET_TICKET_TYPES, params);
export const getActiveTicketTypes = () => api.get(url.GET_ACTIVE_TICKET_TYPES);
export const getTicketTypeById = (id: number) => api.get(`${url.GET_TICKET_TYPE_BY_ID}/${id}`);
export const createTicketType = (data: any) => api.create(url.CREATE_TICKET_TYPE, data);
export const updateTicketType = (id: number, data: any) => api.put(`${url.UPDATE_TICKET_TYPE}/${id}`, data);
export const lockTicketType = (id: number) => api.create(`${url.LOCK_TICKET_TYPE}/${id}/lock`, {});
export const unlockTicketType = (id: number) => api.create(`${url.UNLOCK_TICKET_TYPE}/${id}/unlock`, {});

// Sinh Bộ Số & QR Management - ADDED

// Lấy danh sách kỳ phát hành (filter Status=Published)
export const getKyPhatHanhListApi = (params?: any) => api.get(url.GET_KY_PHAT_HANH_LIST, params);

// Kích hoạt sinh bộ số & QR (POST body rỗng {})
export const sinhBoSoQrApi = (lotteryPeriodId: number) => 
  api.create(`${url.SINH_BO_SO_QR}/${lotteryPeriodId}`, {});

// Lấy tiến trình job (fallback polling)
export const getJobProgressApi = (jobId: string) => 
  api.get(`${url.SINH_BO_SO_QR}/jobs/${jobId}/progress`);

export const getActiveTicketJobsApi = () =>
  api.get(`${url.SINH_BO_SO_QR}/jobs/active`);

export const verifyTicketGenerationApi = (lotteryPeriodId: number) =>
  api.get(`${url.SINH_BO_SO_QR}/${lotteryPeriodId}/verify`);

// Tra cứu 1 vé/dải vé bất kỳ trong bộ vé vừa sinh của 1 kỳ phát hành
export const searchGeneratedTicketsApi = (
  lotteryPeriodId: number,
  numberFrom?: string,
  numberTo?: string,
  symbol?: string
) => api.get(`${url.SINH_BO_SO_QR}/${lotteryPeriodId}/search-tickets`, { numberFrom, numberTo, symbol });

// Lịch sử lỗi job sinh QR (bao gồm cả lỗi do StalledJobWatchdogService phát hiện)
export const getQrJobErrorLogsApi = (lotteryPeriodId: number) =>
  api.get(`${url.GET_QR_JOB_ERROR_LOGS}/${lotteryPeriodId}/error-logs`);

// Export CSV (streaming download)
export const exportQrCsvApi = (lotteryPeriodId: number) => 
  api.get(`${url.EXPORT_QR_CSV}/${lotteryPeriodId}/export-csv`, {
    responseType: 'blob',
  });

// Prize Structure Management (Cơ cấu Giải thưởng) - ADDED
// Rewrite: chỉ còn cấu hình tĩnh 10 hạng giải, dùng chung mọi kỳ — không còn theo issuancePlanId.
// Thêm chiều Miền (Miền Bắc/Miền Trung/Miền Nam) — mỗi miền có cơ cấu riêng, region truyền qua query param
// (GET/initialize/delete) hoặc trong body (PUT) — khớp PayoutRegions bên payout-service.

// Danh mục 10 hạng giải cố định kèm Quantity/ValuePerTicket/TotalValue/MatchingRule, của 1 miền
export const getPrizeTierConfigsApi = (region: string) => api.get(url.GET_PRIZE_TIER_CONFIGS, { region });

// Lưu cấu hình cả 10 hạng giải cùng lúc (1 nút "Lưu cấu hình") của 1 miền
export const updatePrizeTierConfigsApi = (data: { region: string; tiers: any[] }) =>
  api.put(url.UPDATE_PRIZE_TIER_CONFIGS, data);

// Thêm 1 hạng giải mới vào cơ cấu của 1 miền ("+ Thêm hạng giải")
export const createPrizeTierConfigApi = (data: {
  region: string;
  code: string;
  displayName: string;
  colorTheme: string;
  digitCondition: number;
  quantity: number;
  valuePerTicket: number;
  matchingRule: string;
  matchingPosition: string | null;
  matchingDigits: number | null;
}) => api.create(url.UPDATE_PRIZE_TIER_CONFIGS, data);

// Khởi tạo 10 hạng giải mặc định khi cơ cấu của 1 miền đang rỗng
export const initializePrizeTierConfigsApi = (region: string) =>
  api.create(`${url.INITIALIZE_PRIZE_TIER_CONFIGS}?region=${encodeURIComponent(region)}`, {});

// Xoá (soft-delete) 1 hạng giải khỏi cơ cấu của 1 miền, VD bỏ hẳn Giải Tám nếu không dùng
export const deletePrizeTierConfigApi = (region: string, code: string) =>
  api.delete(`${url.DELETE_PRIZE_TIER_CONFIG}/${code}?region=${encodeURIComponent(region)}`);

// Draw Result Management (Kết quả Quay số) - ADDED

// Kết quả quay số (số trúng thật) của 1 kỳ đang chọn, theo miền đang chọn trên FE
export const getDrawResultByPlanApi = (issuancePlanId: number, region: string) =>
  api.get(`${url.GET_DRAW_RESULT_BY_PLAN}/${issuancePlanId}`, { region });

// Lưu kết quả quay số của 1 kỳ (ghi đè toàn bộ, theo miền)
export const saveDrawResultApi = (issuancePlanId: number, data: { region: string; entries: any[] }) =>
  api.put(`${url.SAVE_DRAW_RESULT}/${issuancePlanId}`, data);

// Đọc danh sách Kỳ phát hành từ ticket-service (chỉ đọc, cross-service)
export const getIssuancePlansApi = (params?: any) => api.get(url.GET_ISSUANCE_PLANS, params);

// Brand Management - ADDED

// Lấy thông tin thương hiệu hiện tại
export const getBrandInfo = () => api.get(url.GET_BRAND_INFO);

// Cập nhật thông tin thương hiệu
export const updateBrand = (data: any) => api.put(url.UPDATE_BRAND_INFO, data);

// Upload logo
export const uploadBrandLogo = (formData: FormData) =>
  api.create(url.UPLOAD_BRAND_LOGO, formData);

// Xóa logo
export const deleteBrandLogo = () => api.delete(url.DELETE_BRAND_LOGO);

// Notification Management - ADDED

// Lấy danh sách thông báo (phân trang/lọc)
export const getNotifications = (params?: any) => api.get(url.GET_NOTIFICATIONS, params);

// Lấy số lượng thông báo chưa đọc
export const getNotificationUnreadCount = () => api.get(url.GET_NOTIFICATION_UNREAD_COUNT);

// Đánh dấu 1 thông báo đã đọc
export const markNotificationAsRead = (id: number | string) =>
  api.put(`${url.MARK_NOTIFICATION_READ}/${id}/read`, {});

// Đánh dấu tất cả thông báo đã đọc
export const markAllNotificationsAsRead = () => api.put(url.MARK_ALL_NOTIFICATIONS_READ, {});

// Prize Claim Dossier (Thẩm định Hồ sơ Trả thưởng) - ADDED

// Danh sách hồ sơ (phân trang, lọc theo trạng thái/CCCD/số vé — cũng dùng để "tra cứu nhanh" FR-002)
export const getClaimDossiersApi = (params?: any) => api.get(url.GET_CLAIM_DOSSIERS, params);

// Chi tiết 1 hồ sơ
export const getClaimDossierByIdApi = (id: number) => api.get(`${url.GET_CLAIM_DOSSIER_BY_ID}/${id}`);

// Tạo hồ sơ mới — server tự chấm vé + tự tính Thuế TNCN, KHÔNG gửi prizeTierCode/prizeAmount
export const createClaimDossierApi = (data: {
  issuancePlanId: number;
  symbol: string;
  ticketNumber: string;
  claimantName: string;
  claimantIdNumber: string;
}) => api.create(url.CREATE_CLAIM_DOSSIER, data);

// Ký duyệt hồ sơ
export const approveClaimDossierApi = (id: number) => api.create(`${url.APPROVE_CLAIM_DOSSIER}/${id}/approve`, {});

// Hủy hồ sơ
export const cancelClaimDossierApi = (id: number, reason?: string) =>
  api.create(`${url.CANCEL_CLAIM_DOSSIER}/${id}/cancel`, { reason });

// Kế toán Chi trả — "Chuyển khoản": ChuaChi -> DaChi (chỉ áp dụng hồ sơ đã Thẩm định)
export const payClaimDossierApi = (id: number) => api.create(`${url.PAY_CLAIM_DOSSIER}/${id}/pay`, {});

// Xem trước Giải trúng/Giá trị giải thưởng gốc + Thuế TNCN/Thực lĩnh khi nhập đủ Kỳ vé + Số vé — KHÔNG lưu DB
export const previewClaimDossierApi = (params: { issuancePlanId: number; ticketNumber: string }) =>
  api.get(url.PREVIEW_CLAIM_DOSSIER, { IssuancePlanId: params.issuancePlanId, TicketNumber: params.ticketNumber });

// Quét ảnh CCCD mặt trước (OCR local, không lưu DB) để gợi ý điền sẵn Họ và tên/Số CCCD — CHỈ mang tính gợi ý,
// nhân viên phải kiểm tra lại trước khi lưu.
export const scanCccdImageApi = (file: File) => {
  const formData = new FormData();
  formData.append('File', file);
  return api.create(url.SCAN_CCCD_CLAIM_DOSSIER, formData);
};
